import React, { useState } from 'react';
import classNames from 'classnames';
import { sendEvent } from '@JohnLewisPartnership/experiments-utils';
import styles from './MobileMenuTabs.scss';

export const MobileMenuTabs = ({ onActiveTabChange, isMoneyTabEnabled }) => {
  const [activeTab, setActiveTab] = useState('Shop');
  const menuItems = [
    { name: 'Shop' },
    { name: 'Brands' },
    { name: 'Services' },
    { name: 'Help' },
  ];

  if (isMoneyTabEnabled) {
    menuItems.push({ name: 'Money' });
  }

  const handleTabClick = tab => {
    setActiveTab(tab);
    onActiveTabChange(tab);
    if (tab !== 'Shop') {
      sendEvent(`navigation.tab.${tab.toLowerCase()}.click`);
    }
  };

  return (
    <div
      className={classNames(styles.mobileMenuTabs, {
        [styles['mobileMenuTabs--hasMoneyTab']]: isMoneyTabEnabled,
      })}
    >
      <ul className={styles['mobileMenuTabs-list']}>
        {menuItems.map(menuItem => (
          <li
            key={menuItem.name}
            className={classNames(styles['mobileMenuTabs-listItem'], {
              [styles['mobileMenuTabs-listItem--isActive']]:
                menuItem.name === activeTab,
            })}
          >
            <button
              className={styles['mobileMenuTabs-button']}
              onClick={() => handleTabClick(menuItem.name)}
            >
              {menuItem.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
